<div *ngFor="let banner of banners" class="banner full-width" [innerHTML]="sanitizeBannerHtml(banner.message)">
</div>
